import React, { useState,useEffect } from 'react';
import './SearchBar.css';
import parse from 'html-react-parser'

const SearchBar = ({
  type='unknown',
  placeholder = 'Search...',
  onSearch = () => {},
  onChange = () => {},
  fetchResults = async () => [],
  returnValueOnSearch = false,
  fetchOnInput = true,
  showLoadingIcon = false,
  styleOverrides = {},
  useValueAsText = false,
  displaytext='',
  text = '',
  value = '',
  refresh
}) => {
  const [query, setQuery] = useState(text);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  const [selectedText, setSelectedText] = useState(text);

  const [initvalue, setInitValue] = useState(value??'')
  const [inittext, setInitText] = useState(text??'')
  const [initdisplaytext, setInitDisplayText] = useState(displaytext??'')
  const [strefresh,setRefresh] = useState(new Date().getTime())

  useEffect(()=>{
    if(refresh > strefresh)
      setRefresh(refresh)

    if((displaytext??"") > "" && (initdisplaytext !== displaytext)){
      setQuery(displaytext)
      setInitDisplayText(displaytext)
    }

    if((value??"") > "" && (initvalue !== value)){
      setInitValue(value)
      setSelectedValue(value)
    }

    if((text??"") > "" && (inittext !== text)){
      setInitText(text)
      setSelectedText(text)
    }

  },[refresh, strefresh,setRefresh, value,initvalue, text,inittext,displaytext, initdisplaytext,  setInitValue, setSelectedValue, setInitText, setSelectedText])

  const handleSearch = async () => {
    if (!fetchResults) return;
    setLoading(true);
    const fetched = await fetchResults(query);
    setResults(fetched || []);
    setLoading(false);
    if (returnValueOnSearch && fetched?.length) {
      setSelectedValue(fetched[0].value);
      onSearch(fetched[0].value);
    } else {
      onSearch(query);
    }
  };

  const handleChange = (e) => {
    const val = e.target.value;
    let selval = selectedValue;
    let seltxt = selectedText;
    if(val !== selectedText) {
      selval="";
      seltxt = ""
      setSelectedValue("");
      setSelectedText("")
    }
    setQuery(val);
    onChange({text:val , value: null, selectedvalue: selval, selectedtext: seltxt, registered_address:'' });
    if (fetchOnInput) handleSearch();
  };

  const handleSelect = (item) => {
    setQuery(item.displaytext);
    setSelectedValue(item.value);
    setSelectedText(item.text)
    setResults([]);
    onChange({text:item.text , value: item.value, selectedvalue: item.value, selectedtext: item.text, registered_address: item.registered_address??""});
  };

  return (
    <div key={`sbw_${type}`} className="search-bar-wrapper" style={styleOverrides.wrapper}  >
      <div key={`ig_${type}`} className="input-group" style={styleOverrides.inputGroup}>
        <input
          name={`fld_srch_${type}_${new Date().getTime()}`}
          key={`it_${type}`}
          type="text"
          value={query??""}
          placeholder={placeholder}
          onChange={handleChange}
          style={styleOverrides.input}
        />
        <button  type="button"  onClick={handleSearch} className="search-icon-button" style={styleOverrides.button}>
          {showLoadingIcon && loading ? (
            <div className="spinner"></div>
          ) : (
            <span role="img" aria-label="Search">🔍</span>
          )}
        </button>
      </div>
      {results.length > 0 && (
        <ul className="dropdown" style={styleOverrides.dropdown}>
          {results.map((item, idx) => (
            <li key={idx} onClick={() => handleSelect(item)} style={styleOverrides.item} selected={selectedValue===item.value}>
              {parse(item.dropdown)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchBar;